<template>
  <v-app>
    <!-- <v-app-bar :elevation="1">
      <template v-slot:prepend>
        <v-app-bar-nav-icon></v-app-bar-nav-icon>
      </template>
      <v-app-bar-title><b style="font-size: 36px;"><router-link to="/" style="text-decoration: none; color: black;">Dummy M:{{ baseStore.isMobile }}
        <span v-if="userData"> {{ userData.user_id }}</span>  </router-link></b>&nbsp;&nbsp;  <span style="font-size: 24px;"></span></v-app-bar-title>

    </v-app-bar> -->

    <v-app-bar
      class="primary-app-bar"
      app
      elevation="1"
      clipped-left
    >
      <!-- Menü bleibt -->
      <v-app-bar-nav-icon
        style="font-size: 18px"
        @click="showMenue = !showMenue"
      ></v-app-bar-nav-icon>

      <router-link to="/" class="brand-link">
        <span v-if="baseStore.isDesktop" class="brand-text">
          Team<span class="brand-accent">Waizmann</span>
        </span>
        <span v-else class="brand-text brand-text--mobile">
          Team<span class="brand-accent">Waizmann</span>
        </span>
      </router-link>
   

      <v-spacer></v-spacer>

      <!-- Login bleibt (aber clean) -->
      <div class="header-actions">
        <v-btn
          v-if="!userStore.userData && baseStore.isDesktop"
          class="header-btn header-btn--ghost"
          router-link
          to="/login"
        >
          WaizmannTabellen anfordern
        </v-btn>
        <v-btn
          v-if="!userStore.userData && baseStore.isDesktop"
          class="header-btn header-btn--ghost"
          router-link
          to="/praxiswebinare"
        >
          Waizmann Webinare
        </v-btn>
        <v-btn
          v-if="userStore.userData && baseStore.isDesktop"
          class="header-btn header-btn--ghost"
          router-link
          to="/waizmanntabellen_bestellen"
        >
          WaizmannTabellen anfordern
        </v-btn>
        <v-btn
          v-if="userStore.userData && baseStore.isDesktop"
          class="header-btn header-btn--ghost"
          router-link
          to="/praxiswebinare"
        >
          Waizmann Webinare
        </v-btn>
        <v-btn
          v-if="!userStore.userData"
          class="header-btn header-btn--ghost"
          @click="toggleLogin"
        >
          Login
        </v-btn>
      </div>
      <v-btn
        outlined
        size="large"
        color="primary"
        class="header-btn"
        @click="startLogout"
        v-if="userStore.userData"
      >Logout</v-btn>

    </v-app-bar>

    <v-navigation-drawer
      v-model="showMenue"
      style="max-width: 260px;"
      app
      clipped
    >
      <MenueDefault v-if="showMenue" />
    </v-navigation-drawer>

    <LoaderOverlay />
    <ErrorOverlay />
    <SuccessOverlay />

    <!-- Neues, cleanes Basislayout -->
    <div class="page" :class="{ 'page--with-drawer': showMenue && baseStore.isDesktop }">
      <div class="page__inner">
        <div class="page-grid" :class="{ 'page-grid--no-aside': !showSticky }">
          <main class="main">
            <section class="content-surface">
              <router-view></router-view>
            </section>
          </main>

          <!-- Sticky Box (rechts oben, 240x480, Waizmann Blau) -->
          <aside v-if="showSticky" class="aside">
            <div class="sticky-box">
              <span class="sticky-box__mark" aria-hidden="true">®</span>
              <nav class="sticky-nav" aria-label="Schnellzugriff">
                <router-link class="sticky-nav__link  sticky-nav__link--accent" to="/waizmanntabellen_bestellen">
                  WaizmannTabellen anfordern
                </router-link>
                <router-link class="sticky-nav__link sticky-nav__link--accent" to="/praxiswebinare">
                  Waizmann Webinare
                </router-link>
              </nav>

              <div class="sticky-box__footnote">
                <span class="sticky-box__footnote-line sticky-box__footnote-line--strong">Das Original</span>
                <span class="sticky-box__footnote-line">seit 1995</span>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </div>

    <v-footer app>
      <v-col class="text-center">
        <span>&copy; 2023 TeamWaizmann. Alle Rechte vorbehalten. <router-link class="yesLink" to="/info/Impressum" >Impressum</router-link></span>
      </v-col>
    </v-footer>
    <v-dialog v-model="userStore.showLogin" width="666">
      <v-card>
        <v-card-text>
          <LoginView :newRoute="newRoute" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script setup>
import { inject, ref, computed, onMounted, watch, provide } from 'vue'
import { storeToRefs } from 'pinia'
import { useRouter, useRoute } from 'vue-router'
import MenueDefault from '@/components/sites/modules/MenueDefault.vue';
import  LoginView from '@/components/objects/user/LoginView.vue'
import { useSocialScripts } from '@/composables/useSocialScripts'


// Stores und Services injizieren
const baseCalls = inject('baseCalls')
const userStore = inject('userStore')
const baseStore = inject('baseStore')
const successStore = inject('successStore');
const router = useRouter()
const route = useRoute()

// Reaktive Variablen
const showMenue = ref(false)
const newRoute = ref('/waizmanntabellen_bestellen')

const { userData } = storeToRefs(userStore)

// Routes where the right box should appear.
// Adjust this list as needed.
const stickyRoutes = [
  '/',
  '/home'
]

const showSticky = computed(() => {
  if (!baseStore.isDesktop) {
    return false
  }
  return stickyRoutes.some((path) => route.path === path || route.path.startsWith(path + '/'))
})

// Seitenmetadaten setzen


// Aktuelle Route initial setzen
//const route = useRoute()
//newRoute.value = route.fullPath

// Bei jeder Routenänderung aktualisieren
// watch(
//   () => route.fullPath,
//   (newVal) => {
//     newRoute.value = newVal
//   }
// )

// Extension-Logik
function toggleLogin() {
  if (!userStore.showLogin) {
    userStore.setLoginView(true)
  }
  newRoute.value = '/waizmanntabellen_bestellen'
}

async function startLogout() {
  const data = { action: 'logout', id: 0 }
  try {
    const response = await baseCalls.userGet(data)
    if (response.data.success) {
      console.log('logout success')
      userStore.setUser(false)
      successStore.setSuccess(true, 'Logout erfolgreich', 'Sie wurden erfolgreich ausgeloggt.')
      router.push("/")
    }
  } catch (err) {
    console.log(err)
  }
}


async function getLoggedUser() {
  const data = { action: 'loggeduser',id: 0 }
  try {
    const response = await baseCalls.userGet(data)
    if (response.data.user) {
      userStore.setUser(response.data.user)
    
    } 
  } catch (err) {
    console.log(err)
  } 
}
watch(userData, (newValue) => {
  if (newValue && baseStore.isDesktop) {
    showMenue.value = true;
  }else {
    showMenue.value = false;
  }
});

// Watcher für Routenänderungen
watch(
  () => route.path,
  () => {
    scrollToTop();
  }
);

// Event-Listener hinzufügen, wenn die Komponente gemounted wird
onMounted(() => {
  getLoggedUser();

  router.afterEach(() => {
    scrollToTop();
  });
})

// Provide to all components
const { isInstagramLoaded, loadInstagramScript, processInstagramEmbeds } = useSocialScripts()

// Provide to all components
provide('isInstagramLoaded', isInstagramLoaded)
provide('processInstagramEmbeds', processInstagramEmbeds)

onMounted(() => {
  loadInstagramScript()
})

// Funktion zum Scrollen an den Anfang des Containers
const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

</script>
<style>

a {
    color: #1976d2; 
    cursor: pointer;
    text-decoration: none;
  
  }
  ul {
    margin-left: 20px;
  }
  li {
    margin-bottom: 2px;
  }
  .noUnderline {
    text-decoration: none;
  }
/* Stil für alle v-btn-Komponenten */
.v-btn {
  text-transform: none; /* Setzt den Text auf normale Buchstaben */
}

.noLink {
    color: black;
    text-decoration: none !important;
  }


  .yesLink {
    color: #1976d2; 
    cursor: pointer;
    text-decoration: none;
  }

.router-container {
  /* Falls der Container scrollbar sein soll */
  overflow-y: auto;
  max-height: calc(100vh - [höhe der Navbar und anderer Elemente]);
}
:root .text-blue {
       color: #3166a5 !important;
     }

.top-info-bar {
  background: linear-gradient(90deg, #e8f3ff, #f5fbff);
  height: 40px;
  position: fixed;
  width: 100%;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  font-size: 15px;
  color: #1f3a63;
}

.top-info-bar__left,
.top-info-bar__right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.top-info-bar .divider {
  opacity: 0.6;
}

.primary-app-bar {
  background: #ffffff;
  border-bottom: 1px solid #e1e6ef;
}

.brand-link {
  text-decoration: none;
  color: inherit;
}

.brand-text {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.brand-text--mobile {
  font-size: 20px;
}

.brand-accent {
  color: #3166a5;
}

.brand-claim {
  margin-left: 10px;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: 0.3px;
  color: rgba(16, 42, 67, 0.65);
  white-space: nowrap;
}

/* ---- New clean layout ---- */

:root {
  --wz-blue: #3166a5;
  --wz-ink: #102a43;
  --wz-muted: rgba(16, 42, 67, 0.72);
  --wz-border: rgba(16, 42, 67, 0.10);
  --wz-surface: #ffffff;
  --wz-bg: #f6f8fb;
  --wz-radius-lg: 8px;
  --wz-radius-md: 6px;
  --wz-radius-card: 3px;
}

.header-actions {
  display: flex;
  gap: 10px;
  align-items: center;
  margin-right: 8px;
}

.header-btn {
  text-transform: none;
  border-radius: 4px;
  font-weight: 700;
  letter-spacing: 0.2px;
  position: relative;
  overflow: hidden;
  padding-left: 48px;
}

.header-btn::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  aspect-ratio: 105 / 168;
  width: auto;
  background: var(--wz-blue);
}

.header-btn .v-btn__content {
  position: relative;
  z-index: 1;
}

.header-btn--primary {
  background: var(--wz-blue);
  color: #fff;
}

.header-btn--ghost {
  border: 1px solid var(--wz-border);
  color: var(--wz-ink);
}

.page {
  background: var(--wz-bg);
  min-height: 100vh;
  padding-bottom: 40px;
  /* top-info-bar (40px) + app-bar (~64px) */
  padding-top: 104px;
}

.page--with-drawer {
  padding-left: 260px;
}

/* Mobile: Claim-Bar ist aus, daher weniger Padding */
@media (max-width: 960px) {
  .page {
    padding-top: 64px;
  }
  .page--with-drawer {
    padding-left: 0;
  }
}

.page__inner {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 18px;
}

.page-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 240px;
  gap: 24px;
  align-items: start;
}

.page-grid--no-aside {
  grid-template-columns: 1fr;
}

@media (max-width: 960px) {
  .page-grid {
    grid-template-columns: 1fr;
  }
}


.content-surface {
  margin-top: 18px;
  background: var(--wz-surface);
  border: 1px solid var(--wz-border);
  border-radius: var(--wz-radius-lg);
  padding: 18px;
  min-height: 520px;
}

.aside {
  position: relative;
  align-self: stretch;
}

.sticky-box {
  width: 240px;
  height: auto;
  aspect-ratio: 105 / 186;
  position: sticky;
  top: 122px; /* align under fixed bars */
  border-radius: 4px;
  background: var(--wz-blue);
  color: #fff;
  padding: 18px;
  box-shadow: 0 18px 40px rgba(49, 102, 165, 0.25);
  display: flex;
  flex-direction: column;
}

.sticky-box__label {
  font-size: 12px;
  opacity: 0.85;
  font-weight: 800;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.sticky-box__title {
  margin-top: 6px;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: 0.2px;
}

.sticky-box__actions {
  margin-top: 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.sticky-nav {
  margin-top: 24px;
  display: flex;
  flex-direction: column;
}

.sticky-box__mark {
  position: absolute;
  top: 10px;
  right: 12px;
  font-size: 20px;
  font-weight: 800;
  opacity: 0.9;
}

.sticky-nav__link {
  display: block;
  padding: 14px 10px;
  color: #ffffff;
  text-decoration: none;
  font-weight: 900;
  letter-spacing: 0.2px;
  font-size: 18px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.18);
}

.sticky-nav__link:hover {
  background: rgba(255, 255, 255, 0.12);
}

.sticky-nav__link:last-child:not(.sticky-nav__link--accent) {
  border-bottom: none;
}

.sticky-nav__link--accent {
  border-bottom: 1px solid rgba(173, 200, 235, 0.6);
}

.sticky-btn {
  appearance: none;
  width: 100%;
  text-align: left;
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: rgba(255, 255, 255, 0.14);
  color: #fff;
  border-radius: var(--wz-radius-md);
  padding: 12px 12px;
  font-weight: 800;
  cursor: pointer;
  transition: transform 0.12s ease, background 0.12s ease;
}

.sticky-btn:hover {
  transform: translateY(-1px);
  background: rgba(255, 255, 255, 0.18);
}

.sticky-btn--ghost {
  background: rgba(255, 255, 255, 0.10);
}

.sticky-box__footnote {
  margin-top: auto;
  text-align: right;
  opacity: 0.95;
  line-height: 1.1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.sticky-box__footnote-line {
  font-size: 20px;
  font-weight: 800;
  letter-spacing: 0.2px;
}

.sticky-box__footnote-line--strong {
  font-size: 24px;
  font-weight: 900;
}
</style>
